export const safeSum = (...values: (number | string | undefined)[]): number => {
  return values.reduce<number>((result, value) => result + Number(value || 0), 0);
};
